import React from 'react';

import FooterFull from './Full';
import FooterCampaign from './Campaign';

import './style.scss';

const Footer = ({ variant, campaignEntity }) => {
  switch (variant) {
    case 'campaign':
      return <FooterCampaign campaignEntity={campaignEntity} />;
    case 'privacy':
      return <></>;
    default:
      return <FooterFull />;
  }
};

export default Footer;
